import React from 'react';

import {ErrorMessage, ErrorMessages} from 'bulk-workflows/BulkWorkflowComponents';

interface BulkTranslationErrorsProps {
  errors: Array<string>;
}

const BulkTranslationErrors = ({errors}: BulkTranslationErrorsProps): JSX.Element => (
  <div>
    {errors.length > 0 && (
      <ErrorMessages>
        {errors.map((error, i) => (
          <ErrorMessage key={i}>{error}</ErrorMessage>
        ))}
      </ErrorMessages>
    )}
  </div>
);

export default BulkTranslationErrors;
